/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_TruckInputs */

const en_val_truck = /** @type {(inputs: Val_TruckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Truck`)
};

const es_val_truck = /** @type {(inputs: Val_TruckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camión`)
};

const fr_val_truck = /** @type {(inputs: Val_TruckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camion`)
};

const de_val_truck = /** @type {(inputs: Val_TruckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LKW`)
};

const ja_val_truck = /** @type {(inputs: Val_TruckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラック`)
};

const zh_val_truck = /** @type {(inputs: Val_TruckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卡车`)
};

const ar_val_truck = /** @type {(inputs: Val_TruckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شاحنة`)
};

const id_val_truck = /** @type {(inputs: Val_TruckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Truk`)
};

const it_val_truck = /** @type {(inputs: Val_TruckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camion`)
};

const ru_val_truck = /** @type {(inputs: Val_TruckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Грузовик/Пикап`)
};

const pt_val_truck = /** @type {(inputs: Val_TruckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caminhão`)
};

const ko_val_truck = /** @type {(inputs: Val_TruckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`트럭`)
};

/**
* | output |
* | --- |
* | "Truck" |
*
* @param {Val_TruckInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_truck = /** @type {((inputs?: Val_TruckInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_TruckInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_truck(inputs)
	if (locale === "es") return es_val_truck(inputs)
	if (locale === "fr") return fr_val_truck(inputs)
	if (locale === "de") return de_val_truck(inputs)
	if (locale === "ja") return ja_val_truck(inputs)
	if (locale === "zh") return zh_val_truck(inputs)
	if (locale === "ar") return ar_val_truck(inputs)
	if (locale === "id") return id_val_truck(inputs)
	if (locale === "it") return it_val_truck(inputs)
	if (locale === "ru") return ru_val_truck(inputs)
	if (locale === "pt") return pt_val_truck(inputs)
	return ko_val_truck(inputs)
});